import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'abbreviateLastName' })
export class AbbreviateLastNamePipe implements PipeTransform {
  transform(fullName: string): string {
    const splitName = fullName.split(' ');
    if (splitName.length < 2) {
      return fullName;
    }
    return splitName[0] + ' ' + splitName[1][0] + '.';
  }
}
